import { render, staticRenderFns } from "./GoalDetails.vue?vue&type=template&id=f2f55dba&scoped=true&"
import script from "./GoalDetails.vue?vue&type=script&lang=js&"
export * from "./GoalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f55dba",
  null
  
)

/* custom blocks */
import block0 from "./GoalDetails.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2f55dba')) {
      api.createRecord('f2f55dba', component.options)
    } else {
      api.reload('f2f55dba', component.options)
    }
    module.hot.accept("./GoalDetails.vue?vue&type=template&id=f2f55dba&scoped=true&", function () {
      api.rerender('f2f55dba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/goal/GoalDetails.vue"
export default component.exports